import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '../../shared/user/user';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { AccountLimits, InboundHandlingStrategyType } from '../../account/account.model';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { Ng1ModalService } from '../../shared/ng1/ng1-modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-receive-incoming-call-agents-online',
  templateUrl: './receive-incoming-call-agents-online.component.html',
  styleUrls: ['./receive-incoming-call-agents-online.component.scss']
})
export class ReceiveIncomingCallAgentsOnlineComponent implements OnInit {
  @Input() inboundStrategyType;
  @Output() changed = new EventEmitter();

  public options: InboundHandlingStrategyType[] = [
    InboundHandlingStrategyType.RANDOM_CASCADE,
    InboundHandlingStrategyType.LONGEST_IDLE,
    InboundHandlingStrategyType.BROADCAST
  ];
  private availableOptions: InboundHandlingStrategyType[];
  public state = this.options[0];
  private users: User[];

  constructor(private store: Store<IState>, private ng1ModalService: Ng1ModalService, private router: Router) {}

  ngOnInit() {
    this.state = this.inboundStrategyType;
    this.store.select(getLimitsSelector).subscribe((limits: AccountLimits) => {
      this.availableOptions = limits.availableInboundStrategies || [];
    });
  }

  isActive(state: InboundHandlingStrategyType) {
    return this.state === state;
  }

  isDisabled(strategy: InboundHandlingStrategyType): boolean {
    return !this.availableOptions.includes(strategy);
  }

  selectState(state: InboundHandlingStrategyType) {
    if (this.isDisabled(state)) {
      this.showUpgradeAccountModal();
      return;
    }

    this.state = state;
    this.changed.next({
      user: this.users,
      state: this.state
    });
  }

  showUpgradeAccountModal() {
    return this.ng1ModalService.lazyModalService
      .showModal(
        {
          title: 'TRIAL_MODAL.TITLE',
          body: 'TRIAL_MODAL.TEXT',
          confirm: 'TRIAL_MODAL.CONFIRM'
        },
        true
      )
      .then(() => {
        this.router.navigateByUrl('/choose-plan');
      });
  }

  onUsersListChange(users: User[]) {
    this.users = users;
    this.changed.next({
      user: this.users,
      state: this.state
    });
  }
}
